/* LoveBound — Theme-Verhalten.
   Alle Module sind nach shopify:section:load erneut initialisierbar. */
(function () {
  'use strict';

  var LB = (window.LoveBound = window.LoveBound || {});
  var money = function (cents) {
    var f = (window.Shopify && Shopify.money_format) || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return f.replace(/\{\{\s*amount[^}]*\}\}/, v);
  };
  LB.money = money;

  function announce(msg) {
    var el = document.getElementById('lb-live');
    if (!el) return;
    el.textContent = '';
    window.setTimeout(function () { el.textContent = msg; }, 40);
  }
  LB.announce = announce;

  /* ---------------- Header ---------------- */
  function initHeader(root) {
    root.querySelectorAll('[data-lb-burger]').forEach(function (btn) {
      if (btn.dataset.lbBound) return;
      btn.dataset.lbBound = '1';
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('aria-controls');
        var d = id && document.getElementById(id);
        if (!d) return;
        var open = d.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------- Galerie ---------------- */
  function initGallery(root) {
    root.querySelectorAll('[data-lb-gallery]').forEach(function (g) {
      if (g.dataset.lbBound) return;
      g.dataset.lbBound = '1';
      var slides = Array.prototype.slice.call(g.querySelectorAll('[data-lb-slide]'));
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-lb-thumb]'));
      var counter = g.querySelector('[data-lb-count]');
      if (slides.length < 1) return;
      var i = 0;

      function show(n) {
        if (!slides.length) return;
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var p = g.querySelector('[data-lb-prev]');
      var n = g.querySelector('[data-lb-next]');
      if (p) p.addEventListener('click', function () { show(i - 1); });
      if (n) n.addEventListener('click', function () { show(i + 1); });

      g.addEventListener('lb:media', function (e) {
        var id = e.detail && e.detail.mediaId;
        if (!id) return;
        var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(id); });
        if (idx > -1) show(idx);
      });
      show(0);
    });
  }

  /* ---------------- Personalisierung ---------------- */
  function initPerso(root) {
    root.querySelectorAll('[data-lb-perso]').forEach(function (box) {
      if (box.dataset.lbBound) return;
      box.dataset.lbBound = '1';

      // Wiederholbare Zeilen ohne sichtbare Obergrenze, sofern keine belegte Zahl vorliegt.
      box.querySelectorAll('[data-lb-rows]').forEach(function (rows) {
        var list = rows.querySelector('[data-lb-rowlist]');
        var add = rows.querySelector('[data-lb-rowadd]');
        var tpl = rows.querySelector('template');
        var maxAttr = rows.getAttribute('data-max');
        var max = maxAttr ? parseInt(maxAttr, 10) : parseInt(rows.getAttribute('data-guard') || '12', 10);

        function renumber() {
          var items = list.querySelectorAll('[data-lb-row]');
          items.forEach(function (row, k) {
            row.querySelectorAll('[data-name-tpl]').forEach(function (f) {
              f.setAttribute('name', f.getAttribute('data-name-tpl').replace('__N__', k + 1));
            });
            var del = row.querySelector('[data-lb-rowdel]');
            if (del) del.hidden = items.length <= 1;
          });
          if (add) add.hidden = items.length >= max;
        }
        if (add && tpl) {
          add.addEventListener('click', function () {
            if (list.querySelectorAll('[data-lb-row]').length >= max) return;
            list.appendChild(tpl.content.cloneNode(true));
            renumber();
            var last = list.querySelector('[data-lb-row]:last-child input');
            if (last) last.focus();
          });
        }
        list.addEventListener('click', function (e) {
          var b = e.target.closest('[data-lb-rowdel]');
          if (!b) return;
          var row = b.closest('[data-lb-row]');
          if (row && list.querySelectorAll('[data-lb-row]').length > 1) { row.remove(); renumber(); }
        });
        renumber();
      });

      // Live-Gravurzeile: erscheint erst, wenn wirklich Text eingegeben wurde.
      var out = box.querySelector('[data-lb-engrave-out]');
      var wrap = box.querySelector('[data-lb-engrave]');
      if (out) {
        var src = box.querySelectorAll('[data-lb-engrave-src]');
        var paint = function () {
          var parts = [];
          src.forEach(function (f) { if (f.value && f.value.trim()) parts.push(f.value.trim()); });
          var text = parts.join(' · ');
          out.textContent = text;
          if (wrap) wrap.hidden = text.length === 0;
        };
        src.forEach(function (f) { f.addEventListener('input', paint); });
        paint();
      }
    });
  }

  /* ---------------- Kaufformular ---------------- */
  function initBuy(root) {
    root.querySelectorAll('[data-lb-buy]').forEach(function (form) {
      if (form.hasAttribute('data-lb-split')) return; // Independent parts keep one native multipart form; their controller uses form.elements.
      if (form.dataset.lbBound) return;
      form.dataset.lbBound = '1';

      var submitBtn = form.querySelector('[data-lb-submit]');
      var reason = form.querySelector('[data-lb-blocked-reason]');
      var buyableBase = submitBtn ? !submitBtn.disabled : false;

      function validate(report) {
        var ok = true;
        form.querySelectorAll('[data-lb-required]').forEach(function (f) {
          var wrap = f.closest('.lb-field') || f.parentElement;
          var filled = f.type === 'file' ? (f.files && f.files.length > 0) : !!(f.value && f.value.trim());
          if (!filled) {
            ok = false;
            if (report && wrap) wrap.classList.add('is-invalid');
          } else if (wrap) {
            wrap.classList.remove('is-invalid');
          }
        });
        return ok;
      }

      // CHK-B7: Solange Pflichtangaben fehlen, ist der Kauf gesperrt und die
      // Begruendung steht sichtbar unter dem Knopf.
      var attempted = false;
      function gate() {
        if (!submitBtn) return;
        var ok = validate(false);
        submitBtn.disabled = !buyableBase || !ok;
        if (reason) {
          reason.hidden = !buyableBase || ok;
          // Vor dem ersten Absendeversuch ist der Hinweis eine ruhige Anleitung,
          // erst danach eine Fehlermeldung.
          if (attempted) { reason.setAttribute('data-lb-state', 'error'); }
          else { reason.removeAttribute('data-lb-state'); }
        }
      }
      form.addEventListener('input', gate);
      form.addEventListener('change', gate);
      gate();
      form.addEventListener('submit', function (e) {
        if (!validate(true)) {
          attempted = true;
          gate();
          e.preventDefault();
          var bad = form.querySelector('.lb-field.is-invalid');
          if (bad) {
            bad.scrollIntoView({ block: 'center', behavior: 'smooth' });
            var f = bad.querySelector('input,select,textarea');
            if (f) f.focus();
          }
          announce('Bitte fülle die gekennzeichneten Pflichtfelder aus.');
        }
      });

      // Variantenwahl -> Preis, Verfügbarkeit, Bild, URL
      var data = form.querySelector('[data-lb-variants]');
      if (!data) return;
      var variants = JSON.parse(data.textContent || '[]');
      var idField = form.querySelector('[data-lb-variant-id]');
      var offer = form.querySelector('.lb-offer') || form.closest('.lb-offer');
      var priceStatus = offer && offer.querySelector('[data-lb-price-status]');
      var priceRow = priceStatus && priceStatus.querySelector('.lb-pricerow');
      var priceNote = priceStatus && priceStatus.querySelector('.lb-price__note');
      var blockedStatus = priceStatus && priceStatus.querySelector('.lb-status');
      if (priceStatus && !priceRow) {
        priceRow = document.createElement('div');
        priceRow.className = 'lb-pricerow';
        priceStatus.insertBefore(priceRow, priceStatus.firstChild);
        var newPrice = document.createElement('span');
        newPrice.className = 'lb-price';
        newPrice.setAttribute('data-lb-price', '');
        priceRow.appendChild(newPrice);
      }
      if (priceStatus && !priceNote) {
        priceNote = document.createElement('p');
        priceNote.className = 'lb-price__note';
        priceNote.textContent = priceStatus.dataset.vatNote || '';
        if (priceStatus.dataset.shippingUrl) {
          var shippingLink = document.createElement('a');
          shippingLink.href = priceStatus.dataset.shippingUrl;
          shippingLink.textContent = 'Versandinformationen';
          priceNote.appendChild(document.createTextNode(' · '));
          priceNote.appendChild(shippingLink);
        }
        priceStatus.appendChild(priceNote);
      }
      var priceEl = priceStatus ? priceStatus.querySelector('[data-lb-price]') : document.querySelector('[data-lb-price]');
      var oldPrice = priceRow && priceRow.querySelector('.lb-price__was');
      var saleBadge = priceRow && priceRow.querySelector('.lb-price__sale');
      if (priceRow && !oldPrice) {
        oldPrice = document.createElement('s');
        oldPrice.className = 'lb-price__was';
        priceRow.appendChild(oldPrice);
      }
      if (priceRow && !saleBadge) {
        saleBadge = document.createElement('span');
        saleBadge.className = 'lb-price__sale';
        priceRow.appendChild(saleBadge);
      }
      var stickyPrice = document.querySelector('[data-lb-sticky-price]');
      var submit = form.querySelector('[data-lb-submit]');
      var purchaseLabel = submit ? (submit.dataset.labelBuy || 'In den Warenkorb').split(' – ')[0] : '';
      var gallery = document.querySelector('[data-lb-gallery]');

      function currentOptions() {
        var vals = [];
        form.querySelectorAll('[data-lb-optgroup]').forEach(function (g) {
          var b = g.querySelector('[aria-pressed="true"]');
          vals.push(b ? b.dataset.value : null);
          var out = g.querySelector('[data-lb-optvalue]');
          if (out && b) out.textContent = b.dataset.value;
        });
        return vals;
      }
      function apply() {
        var vals = currentOptions();
        var v = variants.find(function (x) {
          return vals.every(function (val, k) { return val === null || x.options[k] === val; });
        });
        buyableBase = !!(v && v.available && v.price > 0);
        if (idField) idField.value = v ? v.id : '';
        var label = buyableBase ? money(v.price) : '';
        var discounted = buyableBase && v.compare_at_price > v.price;
        if (priceEl) priceEl.textContent = label;
        if (priceRow) priceRow.hidden = !buyableBase;
        if (priceNote) priceNote.hidden = !buyableBase;
        if (blockedStatus) blockedStatus.hidden = buyableBase;
        if (oldPrice) {
          oldPrice.hidden = !discounted;
          oldPrice.textContent = discounted ? money(v.compare_at_price) : '';
        }
        if (saleBadge) {
          saleBadge.hidden = !discounted;
          saleBadge.textContent = discounted ? '–' + (100 - Math.floor(v.price * 100 / v.compare_at_price)) + ' %' : '';
        }
        if (stickyPrice) stickyPrice.textContent = label || stickyPrice.dataset.fallback || '';
        if (submit) {
          submit.dataset.labelBuy = purchaseLabel + (label ? ' – ' + label : '');
          submit.textContent = buyableBase ? submit.dataset.labelBuy
                                       : (submit.dataset.labelBlocked || 'Noch nicht bestellbar');
        }
        gate();
        if (gallery && v && v.featured_media_id) {
          gallery.dispatchEvent(new CustomEvent('lb:media', { detail: { mediaId: v.featured_media_id } }));
        }
        if (history.replaceState && v && v.id) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
        announce('Auswahl aktualisiert.' + (label ? ' Preis ' + label + '.' : ''));
      }
      form.querySelectorAll('[data-lb-optgroup] [data-value]').forEach(function (b) {
        b.addEventListener('click', function () {
          var g = b.closest('[data-lb-optgroup]');
          g.querySelectorAll('[data-value]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          apply();
        });
      });
      apply();
    });
  }

  /* ---------------- Sticky-ATC ---------------- */
  function initSticky(root) {
    var bar = root.querySelector('[data-lb-sticky]');
    if (!bar || bar.dataset.lbBound) return;
    bar.dataset.lbBound = '1';
    var anchorId = bar.getAttribute('data-anchor');
    var anchor = anchorId && document.getElementById(anchorId);
    if (!anchor) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // Erst NACH dem Haupt-CTA einblenden, nie darüber.
        bar.classList.toggle('is-on', e.boundingClientRect.top < 0 && !e.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(anchor);
    anchor.addEventListener('focusin', function () {
      bar.classList.add('is-paused');
    });
    anchor.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!anchor.contains(document.activeElement)) bar.classList.remove('is-paused');
      }, 0);
    });
    // External native form controls belong to the split purchase even when another section sits between them.
    document.addEventListener('focusin', function (e) {
      if (e.target.form && e.target.form.hasAttribute('data-lb-split')) bar.classList.add('is-paused');
    });
    document.addEventListener('focusout', function (e) {
      if (!e.target.form || !e.target.form.hasAttribute('data-lb-split')) return;
      window.setTimeout(function () {
        var active = document.activeElement;
        if (!active || !active.form || !active.form.hasAttribute('data-lb-split')) bar.classList.remove('is-paused');
      }, 0);
    });
    var go = bar.querySelector('[data-lb-sticky-go]');
    if (go) {
      go.addEventListener('click', function () {
        var f = document.querySelector('[data-lb-buy]');
        if (!f) return;
        f.scrollIntoView({ block: 'center', behavior: 'smooth' });
        var first = Array.prototype.find.call(f.elements, function (field) { return field.hasAttribute('data-lb-required'); });
        if (first) window.setTimeout(function () { first.focus(); }, 350);
      });
    }
  }

  /* ---------------- Reveal-Schalter ---------------- */
  function initReveal(root) {
    root.querySelectorAll('[data-lb-reveal]').forEach(function (sec) {
      if (sec.dataset.lbBound) return;
      sec.dataset.lbBound = '1';
      sec.querySelectorAll('[data-lb-reveal-set]').forEach(function (b) {
        b.addEventListener('click', function () {
          var on = b.dataset.lbRevealSet === 'on';
          sec.classList.toggle('is-on', on);
          sec.querySelectorAll('[data-lb-reveal-set]').forEach(function (x) {
            x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ---------------- Warenkorb: Mengenschritte ----------------
     Summen und Zeilen kommen ausschliesslich vom Server. Die Schritte
     aendern nur das Zahlenfeld und schicken das native Cart-Formular ab.
     Zusatzleistungen laufen getrennt in snippets/lb-extras.liquid. */
  function initCart(root) {
    root.querySelectorAll('[data-lb-cart-form]').forEach(function (form) {
      if (form.dataset.lbBound) return;
      form.dataset.lbBound = '1';
      form.addEventListener('click', function (e) {
        var b = e.target.closest('[data-lb-qty]');
        if (!b) return;
        e.preventDefault();
        var input = b.parentElement.querySelector('input[type="number"]');
        if (!input) return;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.lbQty, 10));
        input.value = next;
        announce('Menge ' + next + '. Warenkorb wird aktualisiert.');
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
      form.addEventListener('change', function (e) {
        if (!e.target.matches('input[type="number"][name^="updates"]')) return;
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
  }

  /* ---------------- Bootstrap ---------------- */
  function initAll(root) {
    root = root || document;
    initHeader(root);
    initGallery(root);
    initPerso(root);
    initBuy(root);
    initSticky(root);
    initReveal(root);
    initCart(root);
  }
  LB.init = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();
